import { Row, Container, Accordion } from 'react-bootstrap';

export default function HostFAQs() {
  return (
    <Row>
      <Container className="p-5">
        <h2 className="h2 pb-4 text-center">Frequently Asked Questions</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>How many customers will I get?</Accordion.Header>
            <Accordion.Body>
              <p>
                The average host had over 170 bookings in 2019, for their most
                popular trip.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>What commission do you take?</Accordion.Header>
            <Accordion.Body>
              <p>
                We take a standard commission of 20%, the majority of which is
                spent advertising your trips. We also offer customer rates if
                you want e.g. more advertising, and we'll reach out if this is
                an option for your trips.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>How do I get paid?</Accordion.Header>
            <Accordion.Body>
              <p>
                When a customer pays for your trip, their money is automatically
                put in a trust fund (bank account) just for you. Then, once the
                trip has gone ahead successfully, you'll be paid into the bank
                account of your choice.
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    </Row>
  );
}
